import PropTypes from 'prop-types';
import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';


// @mui
import { useTheme } from '@mui/material/styles';
import { Stack, AppBar, Toolbar, IconButton, Box, Typography, Tooltip, Menu, Avatar, ListItemText, MenuItem } from '@mui/material';
import { useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';

// utils
import { bgBlur } from '../../../utils/cssStyles';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// config
import { HEADER, NAV } from '../../../config-global';
// components
import Logo from '../../../components/logo';
import Iconify from '../../../components/iconify';
import { useSettingsContext } from '../../../components/settings';
import { setUser } from '../../../sections/common/redux/actions';
import UserPageService from '../../../services/UserPageService';

//
import Searchbar from './Searchbar';
import NotificationsPopover from './NotificationsPopover';

import CommonUserModalPopup from '../../../sections/user/common/CommonUserModalPopup';
import { PATH_LOGOUT } from '../../../routes/paths';



// ----------------------------------------------------------------------

Header.propTypes = {
    openNav: PropTypes.bool,
    onOpenNav: PropTypes.func,
    navWidth: PropTypes.number,
};

export default function Header({ openNav, onOpenNav, navWidth }) {
    const location = useLocation();
    const theme = useTheme();

    const navigate = useNavigate();

    const dispatch = useDispatch();


    const { themeLayout } = useSettingsContext();


    const isDesktop = useResponsive('up', 'lg');
    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const userId = loggedInUserDetails?.UserId;
    const appToken = loggedInUserDetails?.token;

    const { search } = location;
    const params = new URLSearchParams(search);
    const code = params.get('code');
    const applicationId = params.get('appId');

    console.log("params", params)
    console.log("loggedInUserDetails", loggedInUserDetails)
    const isOffset = useOffSetTop(HEADER.H_DASHBOARD_DESKTOP);

    const [openModalForActivate, setOpenModalForActivate] = useState(false);

    const [applicationData, setApplicationData] = useState([]);
    useEffect(() => {
        const payload = { UserId: userId, token: appToken }

        UserPageService.GetProjectApplication(payload)
            .then((response) => {
                if (response.status === 200) {

                    setApplicationData(response.data);
                }
                
            })
            .catch((error) => {
                console.log(error)
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId])

    const handleGoToHome = (appId) => {
        const base = window.location.origin; // or config.ApplicationAccessUrl
        const url = new URL('/allprojectsaccess', base);

        url.searchParams.set('userId', userId);
        url.searchParams.set('appToken', appToken);
        url.searchParams.set('appId', appId);

        window.open(url.toString(), '_blank', 'noopener,noreferrer');
        console.log("Opening:", url.toString());
    };



    const handleSubmitActivate = () => {
        setOpenModalForActivate(false);

        UserPageService.UserLogOut()
            .then((logoutResponse) => {
                console.log("logoutResponse.status ", logoutResponse.status);
            })
            .catch(error => {
                console.log("Error ", error);
            });

        const newUserValue = {
            UserId: '',
            UserName: '',
            Role: '',
            RoleId: '',
            RoleAccess: '',
            Designation: '',
            WWID: ''
        };
        dispatch(setUser(newUserValue));
        navigate(PATH_LOGOUT.logout);
    }

    const handleClose = () => {
        setOpenModalForActivate(false);
    }

    const handleLogoutClick = () => {
        setOpenModalForActivate(true);

        
    };
    // open application menu
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClickOnAnchor = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseAnchor = () => {
        setAnchorEl(null);
    };
    // end


    const getShortName = (name) => name
        .split(/(?=[A-Z])/)        // Split CamelCase
        .map(word => word[0])      // Take first letter
        .join('')
        .toUpperCase();


    const renderContent = (
        <>

            {!openNav && (
                <IconButton onClick={onOpenNav} sx={{ mr: 1, color: 'text.primary' }}>
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
            )}

            <img src='/logo/JnJ_MedTech_Horizontal_RGB.png' alt='' style={{ width: 200, height: 40, userSelect: 'none', pointerEvents: 'none',objectFit: 'contain' }} />

            <Stack
                flexGrow={1}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={{ xs: 0.5, sm: 1 }}
            >
                <div>
                    <Tooltip title="Home">
                        <IconButton
                            sx={{
                                width: 36,
                                height: 36,
                                color: "#B50000",
                                ":hover": { color: "#FB0000", cursor: "pointer" },
                            }}
                            onClick={handleClickOnAnchor}
                        >
                            <Iconify icon="ic:baseline-apps" />
                        </IconButton>
                    </Tooltip>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleCloseAnchor}
                        PaperProps={{
                            elevation: 4,
                            sx: {
                                mt: 1,
                                py: 0.5, // Reduce vertical padding inside menu
                                minWidth: 180, // Adjust menu width as needed
                            },
                        }}
                        MenuListProps={{
                            dense: true, // reduces item padding
                        }}
                    >
                        {applicationData
                            // eslint-disable-next-line eqeqeq
                            .filter((app) => app.applicationCode != 3)
                            .map((app, index) => (
                                <MenuItem
                                    key={index}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleGoToHome(app.applicationCode);
                                    }}
                                    sx={{
                                        px: 1.5, // horizontal padding
                                        py: 0.7, // vertical padding (reduce height)
                                        "&:hover": {
                                            backgroundColor: "#FFE5E5",
                                            cursor: "pointer",
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        }}
                                    >
                                        <Avatar sx={{ width: 24, height: 24, fontSize: 10 }}>
                                            {getShortName(app.applicationName)}
                                        </Avatar>
                                        <ListItemText
                                            primary={app.applicationName}
                                            primaryTypographyProps={{ color: "#B50000", fontSize: "0.875rem" }} // smaller font
                                        />
                                    </Box>
                                </MenuItem>
                            ))}
                    </Menu>
                </div>
                <IconButton sx={{
                    width: 40, height: 40, color: '#B50000',
                    ":hover": {
                        cursor: "pointer",
                        color: "#FB0000",
                    },
                }}
                    onClick={handleLogoutClick}

                    >
                    <Iconify icon="mdi:shutdown" />
                </IconButton>
            </Stack>
            {openModalForActivate && <CommonUserModalPopup submitActivate={handleSubmitActivate} close={handleClose} responseMessage='Logout' bodyMessage='Are you sure' />}

        </>
    );

    return (
        <AppBar
            sx={{
                boxShadow: 'none',
                height: HEADER.H_MOBILE,
                zIndex: theme.zIndex.appBar + 1,
                ...bgBlur({
                    color: theme.palette.background.default,
                    backgroundColor: theme.palette.background.paper,
                }),
                transition: theme.transitions.create(['height'], {
                    duration: theme.transitions.duration.shorter,
                }),
                ...(isDesktop && {
                    width: `calc(100% - ${navWidth + 1}px)`,
                    height: HEADER.H_DASHBOARD_DESKTOP,
                    backgroundColor: theme.palette.background.paper,
                    ...(isOffset && {
                        //  height: HEADER.H_DASHBOARD_DESKTOP_OFFSET,
                    }),
                   
                }),
            }}
        >
            <Toolbar
                sx={{
                    height: 1,
                    px: { lg: 5 },
                }}
            >
               
                {renderContent}
            </Toolbar>
        </AppBar>
    );
}
